module.exports = __webpack_public_path__ + "img/retrospect-124-mobile.98a9e087.jpg";